import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MaterialIcon, Button, ListItemColumn, ListItem } from '@pearsontechnology/aero-components';

export const PublishColumnText = styled.div`
  font-size: 14px;
  line-height: 19px;
`;

export const ButtonListItemColumn = styled(ListItemColumn)`
  min-width: fit-content;
  word-break: keep-all;
`;

export const PublishColumnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  `;

export const PublishColumnButton = styled.div`
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-align: center; 
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;

  ${(props) => (props.disabled && `
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
    `
  )}
`;

export const ColoredText = styled.span`
  color: ${(props) => props.color || 'rgba(0,0,0,0.4)'};
`;

export const ActivityName = styled.span`
`;

export const GreyButton = ({ iconName, ...rest }) => (
  <Button iconOnly grey height={34} {...rest}>
    <MaterialIcon id={iconName} />
  </Button>
);

GreyButton.propTypes = {
  iconName: PropTypes.string.isRequired,
};

export const ExpandButton = styled(
  ({ expanded, ...rest }) => <GreyButton iconName={expanded ? 'expand_less' : 'expand_more'} {...rest} />
)`
    margin-right: 5px;
  `;

export const SortButton = styled(
  ({ sort, id, ...rest }) => {
    let order = 'desc';
    if (id === sort.key) {
      order = sort.order;
    }
    return (<GreyButton iconName={order === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'} {...rest} />);
  },
)`
      margin-left: 5px;
    `;

export const ActivityNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  `;

export const OutputTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  `;

export const OutputTypeItem = styled.div`
  margin-top: 4px;
  font-size: 14px;
  font-weight: 200;
`;

export const StyledListItem = styled(ListItem)`
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  box-shadow: ${(props) => ((props.isSelected && !props.disabled) ? '0 4px 10px rgba(0,0,0,0.4)' : 'none')};
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  cursor: ${(props) => ((props.disabled) ? 'not-allowed' : 'default')}
`;